// External libraries
import gql from 'graphql-tag';

export const FETCH_PHONE_METADATA_QUERY = gql`
  query FetchPhoneMetadataQuery($countryCode: CountryCodes!) {
    localeMetadata {
      phone(countryCode: $countryCode) {
        masks {
          mobile
        }
        patterns {
          default
        }
      }
    }
  }
`;
